<template>
  <div class="user_all">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select
        style="width: 220px"
        v-model="selectValue"
        @change="changeRpc()"
        :placeholder="this.$t('title.RPC_service')"
      >
        <el-option
          v-for="item in options"
          :key="item.rpcUrl"
          :label="item.name"
          :value="item.rpcUrl"
        ></el-option>
      </el-select>
      <el-select
        style="margin-left: 5%;width: 220px"
        v-model="selectChain"
        @change="changeChain()"
        :placeholder="$t('title.Please_select_the_chain')"
      >
        <el-option v-for="item in options1" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
    </div>
    <div class="user_search" style="display: flex;align-items:center">
      <span style="width: 100px;display: inline-block">hash：</span>
      <el-input v-model="inputValue" type="primary" style="width: 505px" :placeholder="this.$t('title.Please_enter_content')"></el-input>
      <el-button type="primary" style="margin-left: 5%" @click="search" :loading="isResponse">{{ $t('title.search') }}</el-button>
    </div>
    <div id="app">
      <div class="layout">
        <div class="setting">
          <ul>
            <li>
              <label>{{ $t('title.theme') }}</label>
              <select v-model="theme">
                <option value>{{ this.$t('title.default') }}</option>
                <option value="one-dark">one-dark</option>
                <option value="vs-code">vs-code</option>
              </select>
            </li>
            <li>
              <label>{{ $t('title.Collapse_all') }}</label>
              <select v-model="closed">
                <option :value="false">false</option>
                <option :value="true">true</option>
              </select>
            </li>

            <li>
              <label>deep</label>
              <select v-model="deep">
                <option v-for="item in 10" :value="item">{{item}}</option>
              </select>
            </li>
            <!--                        <li>-->
            <!--                            <label>icon-style</label>-->
            <!--                            <select v-model="iconStyle">-->
            <!--                                <option value="square">square</option>-->
            <!--                                <option value="circle">circle</option>-->
            <!--                                <option value="triangle">triangle</option>-->
            <!--                            </select>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <label>icon-color</label>-->
            <!--                            <input type="color" v-model="color1">-->
            <!--                            <input type="color" v-model="color2">-->
            <!--                        </li>-->
            <li>
              <label>font-size</label>
              <select v-model="fontSize">
                <option v-for="item in 10" :value="item+11">{{item+11}}</option>
              </select>
            </li>
            <li>
              <label for="line-height">line-height</label>
              <select v-model="lineHeight">
                <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
              </select>
            </li>
          </ul>
        </div>
        <div class="content">
          <json-view
            :data="json"
            :theme="theme"
            :deep="deep"
            :iconStyle="iconStyle"
            :fontSize="fontSize"
            :lineHeight="lineHeight"
            :closed="closed"
            :iconColor="iconColor"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jsonView from "../../json-view/index.vue";
import {
  getrpcserver,
  getchaininfo,
  getTransactionByHash
} from "../../../api/interface";

export default {
  name: "HashTrading",
  components: {
    jsonView
  },
  data() {
    return {
      json: {},
      theme: "",
      fontSize: 14,
      lineHeight: 24,
      deep: 3,
      iconStyle: "square",
      closed: false,
      color1: "",
      color2: "",
      isResponse: false,
      selectValue: "",
      options: "",
      selectChain: "",
      options1: "",
      inputValue: "",
    };
  },
  methods: {
    changeRpc() {
      let data = { rpcServer: this.selectValue };
      getchaininfo(data).then(response => {
        this.options1 = response.data;
        this.selectChain = this.options1[0];
      });
    },
    changeChain() {},
    getData() {
      getrpcserver().then(response => {
        this.options = response.data;
        this.selectValue = this.options[0].rpcUrl;
        let data = { rpcServer: this.options[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.options1 = response.data;
          this.selectChain = this.options1[0];
        });
      });
    },
   async search() {
      if (this.inputValue != "") {
        this.isResponse = true;
        let content = this.options.find(item => item.rpcUrl == this.selectValue) || {};
        console.log('--content', content);
        let rpcs = JSON.parse(content.description);
        let data = {
          hash: this.inputValue,
          chainId: this.selectChain + '',
          rpcServer: rpcs[this.selectChain],
          serverUrl: content.browserUrl,
        };
        getTransactionByHash(data, 2)
          .then(res => {
            this.isResponse = false;
            this.json = res.data || {};
            this.$message.success(res.msg)
          })
          .catch(err => {
            this.isResponse = false;
            this.json = err.data || {};
            this.$message.success(err.msg)
          })
        // const res = await getTransactionByHash(data, 2);
      
       
      } else {
        this.$message.error("Please enter the hash correctly and check it out!");
      }
    }
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
}
</style>
<style scoped lang="less">
#app {
  .layout {
    /*width: 1200px;*/
    /*margin: 0 auto;*/

    h1 {
      font-size: 26px;
      font-weight: 400;
      margin: 12px 0;
    }

    a {
      display: block;
      background-color: #f8f8f9;
      border-radius: 4px;
      padding: 8px 16px;
      border: 1px solid #edeff0;
      border-radius: 4px;
      margin-bottom: 20px;
      text-decoration: none;
      color: #2d8cf0;
    }

    .setting {
      border: 1px solid #ccc;
      padding: 10px 20px;

      h3 {
        line-height: 1.6;
        font-size: 18px;
        color: #333;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0;
        padding-right: 20px;

        label {
          font-size: 13px;
          padding-right: 10px;
          color: #333;
        }

        select {
          display: block;
          width: 80px;
          height: 28px;
          background: #fff;
        }
      }
    }

    .content {
      border: 1px solid #ccc;
      border-top: none;
    }
  }
}
</style>
